export default __webpack_public_path__ + "static/media/pgmico(38).42bc2c97.png";